import { useField } from 'formik';

import {
  FieldGroup, Label, Input, Error, Description,
} from '..';

import type { ITextInput } from '../types';

const TextInput = ({
  label,
  placeholder = ' ',
  autocomplete,
  autofocus,
  backgroundColor = 'dark',
  description = '',
  submitted = true,
  labelClassName,
  maxLength,
  errorClassName,
  fieldGroupClassName,
  ...props
}: ITextInput) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);

  return (
    <FieldGroup className={fieldGroupClassName}>
      <Label className={labelClassName} $backgroundColor={backgroundColor} htmlFor={props.id || props.name}>{label}</Label>
      {description.length > 0 && (
        <Description $backgroundColor={backgroundColor}>{description}</Description>
      )}
      <Input {...(maxLength ? { maxLength } : {} )} $backgroundColor={backgroundColor} hasError={Boolean(meta.touched && meta.error)} placeholder={placeholder} autoComplete={autocomplete ? autocomplete : undefined}
      {...field} {...props} autoFocus={autofocus} />
      {(submitted && meta.touched && meta.error) && <Error className={errorClassName}>{meta.error}</Error>}
    </FieldGroup>
  );
};

export default TextInput;
